<template>
    <div class="columns">
        <div class="column">
            <user-transactions></user-transactions>
        </div>
    </div>
</template>

<script>
    import UserTransactions from './../../User/UserTransactions.vue'
    export default {
        components: {
            UserTransactions
        },
        data() {
            return {

            }
        }
    }

</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Users/User/Tabs/UserBalance.vue